const getAllProfessions = ({ commit, state }) => {
    if (state.items.length) return;

    return new Promise((resolve, reject) => {
        axios.get('/api/v1/professions')
            .then(({data}) => {
                commit('SET_PROFESSIONS', data.data);
                resolve();
            })
            .catch(({response}) => {
                reject(response);
            })
    });
};

export default {
    getAllProfessions
};
